module.exports = __webpack_public_path__ + "img/mona_logo.51b70939.png";